import { VIRTUAL_HEIGHT, VIRTUAL_WIDTH } from "../config";

export function drawFakeBanScreen(ctx: CanvasRenderingContext2D): void {
  ctx.fillStyle = "#0a0a0a";
  ctx.fillRect(0, 0, VIRTUAL_WIDTH, VIRTUAL_HEIGHT);

  ctx.fillStyle = "#e53935";
  ctx.font = "bold 30px system-ui, sans-serif";
  ctx.textAlign = "center";
  ctx.fillText("ACCOUNT BANNED", VIRTUAL_WIDTH / 2, 140);

  ctx.fillStyle = "#ffffff";
  ctx.font = "bold 13px system-ui, sans-serif";
  ctx.fillText("Violation: cheating detected.", VIRTUAL_WIDTH / 2, 180);
  ctx.fillText("Run #" + Math.floor(performance.now() % 1_000_000), VIRTUAL_WIDTH / 2, 200);

  ctx.font = "12px system-ui, sans-serif";
  ctx.fillStyle = "#cccccc";
  ctx.fillText("Reason code: 0x7F-LIZ-FRAUD", VIRTUAL_WIDTH / 2, 240);
  ctx.fillText("Your runs have been removed.", VIRTUAL_WIDTH / 2, 260);
  ctx.fillText("To appeal, contact:", VIRTUAL_WIDTH / 2, 290);
  ctx.fillStyle = "#80b3ff";
  ctx.fillText("abuse@lizard-flap.invalid", VIRTUAL_WIDTH / 2, 310);

  ctx.strokeStyle = "#e53935";
  ctx.lineWidth = 3;
  ctx.strokeRect(20, 100, VIRTUAL_WIDTH - 40, 250);

  ctx.fillStyle = "#ff6b6b";
  ctx.font = "10px ui-monospace, monospace";
  ctx.textAlign = "left";
  for (let i = 0; i < 4; i += 1) {
    ctx.fillText(`> session.invalidate(0x${(Math.random() * 0xffffffff) >>> 0})`, 40, 380 + i * 14);
  }
  ctx.textAlign = "left";
}
